module.exports = __webpack_public_path__ + "media/images/area/feature/tohoku/related/id/1-dba43b0424f63c8c8ffd84f3ec132d84.jpg";